const InteriorPadding = 10;
export default InteriorPadding;
